(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const designMode = () => Boolean(window.Shopify && Shopify.designMode);

  function wireCarousel(root, trackSelector, slideSelector, prevSelector, nextSelector, dotsSelector, autoplayAttr = 'autoplayDesktop', intervalAttr = 'interval') {
    if (!root || root.dataset.delaCarouselReady === 'true') return;
    const track = root.querySelector(trackSelector);
    const slides = [...root.querySelectorAll(slideSelector)];
    if (!track || slides.length < 2) return;
    root.dataset.delaCarouselReady = 'true';
    const dotsWrap = root.querySelector(dotsSelector);
    const dots = [];
    if (dotsWrap) {
      dotsWrap.replaceChildren();
      slides.forEach((_, i) => {
        const d = document.createElement('i');
        if (i === 0) d.classList.add('is-active');
        dotsWrap.appendChild(d); dots.push(d);
      });
    }
    let index = 0;
    const go = (i, behavior = reduceMotion.matches ? 'auto' : 'smooth') => {
      index = (i + slides.length) % slides.length;
      const left = slides[index].offsetLeft - track.offsetLeft;
      track.scrollTo({ left, behavior });
      dots.forEach((d, j) => d.classList.toggle('is-active', j === index));
    };
    root.querySelector(prevSelector)?.addEventListener('click', () => go(index - 1));
    root.querySelector(nextSelector)?.addEventListener('click', () => go(index + 1));
    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        let best = 0, distance = Infinity;
        slides.forEach((slide, i) => {
          const d = Math.abs(slide.offsetLeft - track.scrollLeft - track.offsetLeft);
          if (d < distance) { distance = d; best = i; }
        });
        index = best; dots.forEach((d, j) => d.classList.toggle('is-active', j === index));
      });
    }, { passive: true });
    const autoplay = root.dataset[autoplayAttr] === 'true';
    const interval = Math.max(5000, parseInt(root.dataset[intervalAttr] || '7000', 10));
    let timer;
    const stop = () => { if (timer) clearInterval(timer); timer = undefined; };
    const start = () => {
      if (!autoplay || reduceMotion.matches || window.innerWidth < 750 || designMode()) return;
      stop(); timer = setInterval(() => go(index + 1), interval);
    };
    root.addEventListener('pointerenter', stop); root.addEventListener('pointerleave', start);
    root.addEventListener('focusin', stop); root.addEventListener('focusout', start);
    root._delaCarouselGo = go; start();
  }

  const initHero = root => { if (root?.dataset.mode === 'carousel') wireCarousel(root,'[data-dela-v3-track]','[data-dela-v3-slide]','[data-dela-v3-prev]','[data-dela-v3-next]','[data-dela-v3-dots]'); };
  const initFlex = root => { if (root?.dataset.layout === 'carousel') wireCarousel(root,'[data-dela-v31-track]','[data-dela-v31-slide]','[data-dela-v31-prev]','[data-dela-v31-next]','[data-dela-v31-dots]'); };

  function initAnnouncementBehavior() {
    if (designMode()) return;
    const bar = document.querySelector('.announcement-bar');
    if (!bar || bar.dataset.delaAutoHide === 'true') return;
    bar.dataset.delaAutoHide = 'true';
    const update = () => {
      const hidden = window.scrollY > 120;
      bar.style.transform = hidden ? 'translateY(-110%)' : 'translateY(0)';
      bar.style.opacity = hidden ? '0' : '1'; bar.style.pointerEvents = hidden ? 'none' : '';
    };
    bar.style.transition = reduceMotion.matches ? 'none' : 'transform .22s ease, opacity .22s ease';
    update(); window.addEventListener('scroll', update, { passive: true });
  }

  function init(scope = document) {
    scope.querySelectorAll?.('[data-dela-v3-hero]').forEach(initHero);
    scope.querySelectorAll?.('[data-dela-v31-flex]').forEach(initFlex);
    initAnnouncementBehavior();
  }

  function focusSelectedBlock(event) {
    const block = event.target;
    const slide = block?.closest?.('[data-dela-v3-slide],[data-dela-v31-slide]');
    if (!slide) return;
    const root = slide.closest('[data-dela-v3-hero],[data-dela-v31-flex]');
    const slides = [...root.querySelectorAll('[data-dela-v3-slide],[data-dela-v31-slide]')];
    const index = slides.indexOf(slide);
    if (index >= 0 && typeof root._delaCarouselGo === 'function') root._delaCarouselGo(index, 'auto');
    else slide.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', focusSelectedBlock);
})();
